export default __webpack_public_path__ + "static/foto-fake-6d5351566f6b438e3554ec95d9836814.jpg";